var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-indigo-600 bg-indigo-200 border-opacity-20 border-indigo-600 border-2 rounded-md px-5 py-3"
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }